import { IUpdateGestaoEpiUseCase } from "../../../presentation/useCases/update/update_gestao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class UpdateGestaoEpiUseCase implements IUpdateGestaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async updateGestaoEpi(
    idGestaoEpi: number,
    nome: string,
    ativo: number | null,
    especificacao: string | null,
  ): Promise<void> {
    await this.repository.updateGestaoEpi(
      idGestaoEpi,
      nome,
      ativo,
      especificacao,
    );
  }
}
